<template>
    <div :class="[{ 'desktop-header': isDesktop, 'mobile-header': !isDesktop }, { 'scrolled': isScrolled }]">
        <div class="header-view">
            <div class="header-left">
                <nuxt-link :to="isTranslate ? localePath('/account?menu=home') : localePath('/')" class="logo">
                    <CommonImage src="/assets/images/logo_zh@2x.webp" v-if="isChina" class="img"
                        :useElementUI="false" />
                    <CommonImage src="/assets/images/logo_en@2x.webp" v-else class="img-en" :useElementUI="false" />
                    <!-- <i class="iconfont icon-icon_onlineedit img"></i>
                    <div class="point" />
                    <div class="business-text">
                        {{ t('header_pdfEditOne') }}
                    </div> -->
                </nuxt-link>
            </div>
            <div class="header-center" v-if="isDesktop">
                <div class="menu">
                    <div class="menu-item" v-for="(item, index) in menuList" :key="item.path">
                        <div class="menu-item-link" :class="{ 'menu-active': indexRouter === item.id }"
                            @click="handlerNav(item)">
                            {{ t(`${item.name}`) }}
                        </div>
                        <div class="menu-item-line" :class="{ 'menu-item-line-active': indexRouter === item.id }" />
                    </div>
                </div>
            </div>
            <div class="header-right">
                <client-only>
                    <el-select v-model="currentLanguage" @change="handleLanguageChange"  v-if="isDesktop"
                        class="language-select"
                        popper-class="desktop-language-select-dropdown" :placeholder="t('select_language')">
                        <template #prefix>
                            <span class="iconfont icon-icon_earth language-icon"></span>
                        </template>
                        <el-option v-for="item in languageList" :key="item.id" :label="item.name" :value="item.code">
                            <div class="language-option-item">{{ item.name }}</div>
                        </el-option>
                    </el-select>

                    <!-- <el-select v-model="currentLanguage" @change="handleLanguageChange"  v-else
                        class="language-select"
                        popper-class="language-select-dropdown-mobile" :placeholder="t('select_language')">
                        <template #prefix>
                            <span class="iconfont icon-icon_earth language-icon"></span>
                        </template>
                        <el-option v-for="item in languageList" :key="item.id" :label="item.name" :value="item.code">
                            <div class="language-option-item">{{ item.name }}</div>
                        </el-option>
                    </el-select> -->

                    <div class="concat-us" @click="onOperateRecordClick" v-if="isDesktop">
                        <i class="iconfont icon-icon_operation_log1"></i>
                        <span class="concat-title" >
                            {{ t('operate_record_title') }}
                        </span>
                    </div>
                    <div v-else class="mobile-toggle-menu" @click="mobileMenuDrawRef?.toggleMenu?.()">
                        <i class="iconfont icon-icon_tabulation"></i>
                    </div>
                </client-only>
            </div>
        </div>
    </div>
    <MobileMenuDraw ref="mobileMenuDrawRef" @onOperateRecordClick="onOperateRecordClick"/>
</template>

<script setup lang="ts">
import useSystemLanguageStore from '~/store/modules/systemLaunage';
import type { SystemLanguageType } from '~/store/modules/systemLaunage';
import useUserStore from '~/store/modules/user';
import useBasicStore from '~/store/modules/basic';
import { SystemLanguageEnum, Token } from '~/types/const'
import CommonImage from '~/components/CommonImage/CommonImage.vue';
import UserPopover from './UserPopover/index.vue';
import { useI18n } from 'vue-i18n'
import eventBus from 'vue3-eventbus'
import { EventHomeMessage } from '~/config/event'
import 'element-plus/theme-chalk/display.css'
import MobileMenuDraw from './mobileMenuDraw.vue'
const viewport = useViewport();
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
const userStore = useUserStore()
const basicStore = useBasicStore()
const { isChina } = storeToRefs(basicStore)
const { token, userInfo } = storeToRefs(userStore)
const mobileMenuDrawRef = ref<InstanceType<typeof MobileMenuDraw>>()
const systemLanguageStore = useSystemLanguageStore()
const { languageList, systemLanguage } = storeToRefs(systemLanguageStore)
const { t, locale, setLocale } = useI18n()
const localePath = useLocalePath()
const router = useRouter()
const route = useRoute()

const props = defineProps({
    isWorkbench: {
        type: Boolean,
        default: false
    },
    isTranslate: {
        type: Boolean,
        default: false
    }
})
const currentLanguage = computed(() => {
    console.log('currentLanguage', systemLanguage.value?.code, locale.value)
    return locale.value || systemLanguage.value?.code || 'en'
})

// 是否已滚动
const isScrolled = ref(false)

watch(locale, (newVal) => {
    const languageItem = languageList.value.find((item) => item.code === newVal) as SystemLanguageType
    if (languageItem) {
        handleChangeLanguage(languageItem)
    }
}, {deep: true})

// 监听系统语言变化，同步到下拉框
watch(systemLanguage, (newVal) => {
    if (newVal) {
        // 这里不需要手动设置，因为currentLanguage是computed
    }
}, {deep: true})

// 滚动到指定section
const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
        element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
        })
    }
}

const indexRouter = ref(1)
watchEffect(() => {
    if (route.path.includes('/tutorialConsultation') ){
        indexRouter.value = 3
    } else if (route.path.includes('/contactUs')) {
        indexRouter.value = 2
    } else if (route.path.includes('/editor')){
        indexRouter.value = 1
    } else {
        indexRouter.value = 1
    }
});

// 头部导航事件
interface HeaderMenuItem {
    name: string;
    path: string;
    id: number | string;
    routeName?: string;
}

const menuList = ref<HeaderMenuItem[]>([
    { name: 'header_pdfEdit', path: '/', id: 1, routeName: 'index' },
    { name: 'header_contact', path: '/contactUs', id: 2, routeName: 'contactUs' },
    { name: 'editor_tutorial_consultation', path: '/tutorialConsultation', id: 3, routeName: 'tutorialConsultation' },
    // { name: 'header_editor', path: '/editor', id: 'editor-view', routeName: 'editor' }
])

const handlerNav = (item: HeaderMenuItem) => {
    

    const targetRoute = item.routeName ? { name: item.routeName } : { path: item.path }
    const targetPath = localePath(targetRoute)

    navigateTo(targetPath)
}

// 监听滚动，更新active section和滚动状态
const handleScroll = () => {
    console.log('handleScroll')
    const layout = document.getElementById('main-layout-content')
    if (!layout) return
    const scrollPosition = layout.scrollTop
    isScrolled.value = scrollPosition > 50
}

const handleChangeLanguage = (item: SystemLanguageType) => {
    setLocale(item.code as SystemLanguageEnum)
    systemLanguageStore.setLanguage(item.code as SystemLanguageEnum)
    // useCookie('lang').value = item.code
    useHead({
        htmlAttrs: {
            lang: item.code
        }
    })
}

// 下拉框语言切换方法
const handleLanguageChange = (languageCode: string) => {
    const selectedLanguage = languageList.value.find(item => item.code === languageCode)
    if (selectedLanguage) {
        handleChangeLanguage(selectedLanguage)
    }
}

// 操作记录点击方法
const onOperateRecordClick = () => {
    eventBus.emit(EventHomeMessage.operateRecordClick)
}

const switchLanguageHandler = (lang: SystemLanguageEnum) => {
    setTimeout(() => {
        console.log('switchLanguage', lang, languageList.value)
        handleChangeLanguage(languageList.value.find((item) => item.code === lang) as SystemLanguageType)
    }, 2000)
}

onMounted(() => {
    let layout = document.getElementById('main-layout-content')
    layout?.addEventListener('scroll', handleScroll)
    // 初始化时检查当前section和滚动状态
    handleScroll()

    eventBus.on('switchLanguage', switchLanguageHandler)
})

onUnmounted(() => {
    let layout = document.getElementById('main-layout-content')
    layout?.removeEventListener('scroll', handleScroll)
    eventBus.off('switchLanguage', switchLanguageHandler)
})
</script>

<style lang="scss" scoped>
@use './index.scss' as *;
@use './mobile.scss' as *;
</style>    